import { render, staticRenderFns } from "./offerEmployerCard.vue?vue&type=template&id=31fa81a2&scoped=true&"
import script from "./offerEmployerCard.vue?vue&type=script&lang=js&"
export * from "./offerEmployerCard.vue?vue&type=script&lang=js&"
import style0 from "./offerEmployerCard.vue?vue&type=style&index=0&id=31fa81a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fa81a2",
  null
  
)

export default component.exports